import GuestInvitationRouter from './router/guest-invitation-router';

export default GuestInvitationRouter;
